import Image from 'components/Image';

import * as S from './styles';

interface ITeammateBox {
  imageSrc: string;
  name: string;
  position: string;
}

const TeammateBox = ({ imageSrc, name, position }: ITeammateBox) => (
  <S.TeammateBox>
    <Image width={279} height={279} src={imageSrc} />
    <S.Name>{name}</S.Name>
    <S.Position>{position}</S.Position>
  </S.TeammateBox>
);

export default TeammateBox;
